import {onDutyFree} from '@festi/common/constants/channels'
import settings from '@festi/common/constants/settings'

export type RefinementListItem = {
  value: string
  label: string
  highlighted?: string
  count: number
  isRefined: boolean
}

export const priceRangeAttribute = `listings.${[
  settings.channel,
]}.price.lowestPrice`

const storeType = onDutyFree ? 'dutyfree_store' : 'elko_store'

export const ruleContexts = [storeType]
